import { render, staticRenderFns } from "./SuccessOrderPay.vue?vue&type=template&id=240363c2&"
import script from "./SuccessOrderPay.vue?vue&type=script&lang=js&"
export * from "./SuccessOrderPay.vue?vue&type=script&lang=js&"
import style0 from "@/styles/SuccessOrderPay.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports